import isMobile from '../utils/is-mobile';

const accordionHeaders = document.querySelectorAll('.accordion-item__button');

accordionHeaders.forEach((header) => {
  header.addEventListener('click', () => {
    header.setAttribute(
      'aria-expanded',
      !(header.getAttribute('aria-expanded') === 'true'),
    );
  });

  // if 'accordion' is the topbar (sidebar) on CT Strategy Cluster
  // close it on click outside
  if (isMobile()) {
    document.addEventListener('click', ({ target }) => {
      // check if header has attribute expanded
      const isExpanded = header.getAttribute('aria-expanded') === 'true';
      // check if click was outside the parent element of the clicked header
      const isOutside = !header.parentNode.contains(target);

      if (isExpanded && isOutside) {
        header.setAttribute('aria-expanded', 'false');
      }
    });
  }
});
